<template>
    <div class="cases-remarks">
        <div v-if="spa_remarks.length > 0">
            <b-row class="border-bottom py-2" v-for="(remark, index) in spa_remarks" :key="index">
                <b-col cols="12">
                    <p>{{ remark.remark }}</p>
                </b-col>
                <b-col cols="12">
                    <div class="d-flex align-items-center">
                        <small class="font-weight-500 text-truncate">{{ remark.name }}</small>
                        <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="7" height="7" viewBox="0 0 512 512"><path fill="#A4B0C0" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                        <small class="text-muted">{{ remark.created_at | dateTimeFormatString }}</small>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div v-else>No remarks found.</div>
        <b-form class="mt-3" @submit.prevent="addRemarkHandler">
            <b-form-textarea
                id="textarea"
                v-model="new_remark"
                required
                size="md"
            ></b-form-textarea>
            <div class="text-right">
                <b-button type="submit" class="p-0 d-inline-flex bg-transparent shadow-none mt-2">
                    <i class="ni ni-send ml-3" style="font-size:1.2rem"></i>
                </b-button>
            </div>
        </b-form>

    </div>
</template>
<script>
import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader,
        debounce
    } from '@/assets/js/httpImports.js'

export default {
    props:['spa_remarks', 'prod_id', 'is_hestia'],
    data(){
        return{
            new_remark: ''
        }
    },
    mixins: [helperFunctionMixin, notifyFunctionMixin],
    methods:{
        addRemarkHandler(){
            if(this.new_remark === ''){
                return
            }
            let data = {
                remark: this.new_remark,
                things_to_track_id: 3
            }

            if(this.is_hestia)
            {
                const postData = {
                    prod_id: this.prod_id,
                    things_to_track_id: 3,
                    remark: this.new_remark
                }
                axios.post(services.hestia + 'tracking-remark', postData, {headers: getHeader()})
                    .then(res=>{
                        this.new_remark = ''
                        this.notifySuccess('<b>Remark:</b> - Successfully Created.')
                        this.$emit('refresh-lawyer-detail')
                    })
                    .catch(e =>{
                        this.errorFunction(e)
                    })
            }
            else
            {
                axios.post(services.lookup + 'pmp/cases.im2uv2/'+this.prod_id+'/remarks', data, {headers: getHeader()})
                    .then(res=>{
                        this.new_remark = ''
                        this.notifySuccess('<b>Remark:</b> - Successfully Created.')
                        this.$emit('refresh-lawyer-detail')
                    })
                    .catch(e =>{
                        this.errorFunction(e)
                    })
            }

        }
    }
}
</script>